export default {
  ALIPAY_WEB: {
    value: 'alipay-web',
    label: '支付宝',
  },

  WECHAT_SCAN: {
    value: 'wechat-scan',
    label: '微信',
  },
}
